/* ==========================================================================
   LISBON VICE
   ACTIVITY GRID

   COLLECTION ARCHITECTURE

   Each filter corresponds to an actual Shopify collection panel.

   Clicking:
     Full Collection
     Lisbon by Day
     Lisbon by Night
     Tastes & Culture
     Full Adrenaline

   switches between server-rendered Shopify collection grids.

   Product type / badges / tags DO NOT affect filtering.

   Uses Beyond's native Cart custom element:
   customElements.get('cart-element')
   ========================================================================== */


(function () {

  'use strict';


  if (window.__lvActivityGridBound) return;

  window.__lvActivityGridBound = true;


  var ADDED_LABEL = 'Added';
  var DEFAULT_ADD_LABEL = '+ Add';
  var REVERT_MS = 2600;



  /* ==========================================================================
     THEME CART
     ========================================================================== */

  function getThemeCart() {

    if (
      !window.customElements ||
      typeof window.customElements.get !== 'function'
    ) {
      return null;
    }


    return window.customElements.get(
      'cart-element'
    );

  }



  function waitForThemeCart() {

    return new Promise(
      function (
        resolve,
        reject
      ) {

        var attempts = 0;
        var maxAttempts = 50;


        function check() {

          var ThemeCart =
            getThemeCart();


          if (
            ThemeCart &&
            typeof ThemeCart.addItems === 'function'
          ) {

            resolve(
              ThemeCart
            );

            return;

          }


          attempts += 1;


          if (
            attempts >= maxAttempts
          ) {

            reject(
              new Error(
                'Beyond cart element did not become available.'
              )
            );

            return;

          }


          setTimeout(
            check,
            50
          );

        }


        check();

      }
    );

  }



  /* ==========================================================================
     HELPERS
     ========================================================================== */

  function drawerWanted(
    section
  ) {

    return (
      !section ||
      section.getAttribute(
        'data-open-drawer'
      ) !== 'false'
    );

  }



  function announce(
    section,
    message
  ) {

    if (!section) return;


    var status =
      section.querySelector(
        '[data-lv-status]'
      );


    if (!status) return;


    status.textContent = '';


    requestAnimationFrame(
      function () {

        status.textContent =
          message;

      }
    );

  }



  /* ==========================================================================
     PACKAGE / VARIANT PANELS
     ========================================================================== */

  function getTriggerForPanel(
    panel
  ) {

    if (
      !panel ||
      !panel.id
    ) {
      return null;
    }


    return document.querySelector(
      '[data-lv-add][aria-controls="' +
      panel.id +
      '"]'
    );

  }



  function closePackage(
    panel,
    restoreFocus
  ) {

    if (!panel) return;


    panel.hidden =
      true;


    var trigger =
      getTriggerForPanel(
        panel
      );


    if (trigger) {

      trigger.setAttribute(
        'aria-expanded',
        'false'
      );


      if (restoreFocus) {

        trigger.focus();

      }

    }

  }



  function closeAllPackages(
    except
  ) {

    document
      .querySelectorAll(
        '[data-lv-packages]'
      )
      .forEach(
        function (
          panel
        ) {

          if (
            panel === except
          ) {
            return;
          }


          closePackage(
            panel,
            false
          );

        }
      );

  }



  function openPackage(
    panel,
    trigger
  ) {

    if (!panel) return;


    closeAllPackages(
      panel
    );


    panel.hidden =
      false;


    if (trigger) {

      trigger.setAttribute(
        'aria-expanded',
        'true'
      );

    }


    var firstPackage =
      panel.querySelector(
        '[data-lv-package]'
      );


    if (firstPackage) {

      requestAnimationFrame(
        function () {

          firstPackage.focus();

        }
      );

    }

  }



  /* ==========================================================================
     CARD STATE
     ========================================================================== */

  function markAdded(
    button
  ) {

    if (!button) return;


    var card =
      button.closest(
        '.lv-agrid__card'
      );


    var originalLabel =
      button.getAttribute(
        'data-lv-original-label'
      );


    if (!originalLabel) {

      originalLabel =
        button.textContent.trim() ||
        DEFAULT_ADD_LABEL;


      button.setAttribute(
        'data-lv-original-label',
        originalLabel
      );

    }


    button.setAttribute(
      'data-added',
      '1'
    );


    button.textContent =
      ADDED_LABEL;


    if (card) {

      card.classList.add(
        'is-added'
      );

    }


    clearTimeout(
      button.__lvRevert
    );


    button.__lvRevert =
      setTimeout(
        function () {

          button.textContent =
            originalLabel;


          button.removeAttribute(
            'data-added'
          );

        },
        REVERT_MS
      );

  }



  /* ==========================================================================
     SHOPIFY CART SYNC
     ========================================================================== */

  function fetchRealCart() {

    var cartUrl =
      (
        window.Shopify &&
        Shopify.routes &&
        Shopify.routes.cart
      )
        ? Shopify.routes.cart
        : '/cart';


    return fetch(
      cartUrl.replace(
        /\/$/,
        ''
      ) + '.js',
      {

        method:
          'GET',

        headers: {

          Accept:
            'application/json'

        },

        credentials:
          'same-origin',

        cache:
          'no-store'

      }
    )
      .then(
        function (
          response
        ) {

          if (!response.ok) {

            throw new Error(
              'Could not load Shopify cart.'
            );

          }


          return response.json();

        }
      );

  }



  function syncCardsFromCart(
    cart
  ) {

    if (
      !cart ||
      !Array.isArray(
        cart.items
      )
    ) {
      return;
    }


    var cartVariantIds =
      cart.items.map(
        function (
          item
        ) {

          return String(
            item.variant_id
          );

        }
      );


    /*
     * A product may appear in several collection panels.
     * Every copy of that activity gets the correct Added state.
     */

    document
      .querySelectorAll(
        '.lv-agrid__card'
      )
      .forEach(
        function (
          card
        ) {

          var variantIds =
            (
              card.getAttribute(
                'data-variant-ids'
              ) ||
              ''
            )
              .split(',')
              .map(
                function (
                  id
                ) {

                  return id.trim();

                }
              )
              .filter(
                Boolean
              );


          var inCart =
            variantIds.some(
              function (
                id
              ) {

                return (
                  cartVariantIds.indexOf(
                    id
                  ) !== -1
                );

              }
            );


          card.classList.toggle(
            'is-added',
            inCart
          );

        }
      );

  }



  function broadcastLisbonViceCart(
    cart
  ) {

    document.dispatchEvent(
      new CustomEvent(
        'lv:cart:updated',
        {

          detail: {

            cart:
              cart

          }

        }
      )
    );

  }



  function refreshLisbonViceState() {

    return fetchRealCart()
      .then(
        function (
          cart
        ) {

          syncCardsFromCart(
            cart
          );


          broadcastLisbonViceCart(
            cart
          );


          return cart;

        }
      )
      .catch(
        function (
          error
        ) {

          console.warn(
            '[lv-activity-grid] Could not sync cart:',
            error
          );


          return null;

        }
      );

  }



  /* ==========================================================================
     COLLECTION PANELS
     ========================================================================== */

  function showCollection(
    button,
    silent
  ) {

    if (!button) return;


    var section =
      button.closest(
        '[data-lv-agrid]'
      );


    if (!section) return;


    var selectedFilter =
      button.getAttribute(
        'data-lv-filter'
      );


    if (!selectedFilter) return;


    /*
     * Close any variant chooser before changing collection.
     */

    closeAllPackages();



    /*
     * Update active pill.
     */

    section
      .querySelectorAll(
        '[data-lv-filter]'
      )
      .forEach(
        function (
          filterButton
        ) {

          var active =
            filterButton ===
            button;


          filterButton
            .classList
            .toggle(
              'is-active',
              active
            );


          filterButton
            .setAttribute(
              'aria-pressed',
              active
                ? 'true'
                : 'false'
            );

        }
      );



    /*
     * Switch actual collection panels.
     */

    var activePanel =
      null;


    section
      .querySelectorAll(
        '[data-lv-panel]'
      )
      .forEach(
        function (
          panel
        ) {

          var panelKey =
            panel.getAttribute(
              'data-lv-panel-key'
            );


          var active =
            panelKey ===
            selectedFilter;


          panel.hidden =
            !active;


          if (active) {

            activePanel =
              panel;

          }

        }
      );



    /*
     * Fallback to Full Collection if something
     * has been misconfigured.
     */

    if (!activePanel) {

      activePanel =
        section.querySelector(
          '[data-lv-panel-key="all"]'
        );


      if (activePanel) {

        activePanel.hidden =
          false;

      }

    }



    /*
     * Announce actual number of products
     * inside the collection panel.
     */

    if (
      activePanel &&
      !silent
    ) {

      var visibleCount =
        activePanel.querySelectorAll(
          '[data-lv-card]'
        ).length;


      announce(
        section,

        visibleCount +

        (
          visibleCount === 1
            ? ' activity shown.'
            : ' activities shown.'
        )
      );

    }

  }



  /* ==========================================================================
     INITIAL COLLECTION
     ========================================================================== */

  function initialiseCollectionPanels(
    scope
  ) {

    var sections;


    if (
      scope &&
      scope.matches &&
      scope.matches(
        '[data-lv-agrid]'
      )
    ) {

      sections =
        [scope];

    } else if (
      scope &&
      scope.querySelectorAll
    ) {

      sections =
        scope.querySelectorAll(
          '[data-lv-agrid]'
        );

    } else {

      sections =
        document.querySelectorAll(
          '[data-lv-agrid]'
        );

    }


    Array.prototype.forEach.call(
      sections,
      function (
        section
      ) {

        var defaultFilter =
          section.getAttribute(
            'data-lv-default-filter'
          ) ||
          'all';


        var targetButton =
          section.querySelector(
            '[data-lv-filter="' +
            defaultFilter +
            '"]'
          );


        if (!targetButton) {

          targetButton =
            section.querySelector(
              '[data-lv-filter="all"]'
            );

        }


        if (targetButton) {

          showCollection(
            targetButton,
            true
          );

        }

      }
    );

  }



  /* ==========================================================================
     ADD VARIANT
     ========================================================================== */

  async function addVariant(
    button,
    variantId,
    section
  ) {

    if (
      !button ||
      !variantId
    ) {
      return;
    }


    if (
      button.getAttribute(
        'aria-busy'
      ) === 'true'
    ) {
      return;
    }


    button.setAttribute(
      'aria-busy',
      'true'
    );


    button.disabled =
      true;


    try {

      var ThemeCart =
        await waitForThemeCart();


      var sections =
        ThemeCart.sections ||
        ['cart-drawer'];


      var requestOptions = {

        method:
          'POST',

        headers: {

          'Content-Type':
            'application/json',

          Accept:
            'application/json'

        },

        credentials:
          'same-origin',

        body:
          JSON.stringify(
            {

              items: [
                {

                  id:
                    Number(
                      variantId
                    ),

                  quantity:
                    1

                }
              ],

              sections:
                sections

            }
          )

      };


      var drawerTrigger =
        drawerWanted(
          section
        )
          ? button
          : false;


      /*
       * Beyond native add-to-cart.
       */

      await ThemeCart.addItems(
        requestOptions,
        drawerTrigger
      );


      markAdded(
        button
      );


      announce(
        section,

        (
          button.getAttribute(
            'data-lv-title'
          ) ||
          'Activity'
        ) +

        ' added to your plan.'
      );


      await refreshLisbonViceState();


    } catch (
      error
    ) {

      console.error(
        '[lv-activity-grid] Add failed:',
        error
      );


      announce(
        section,

        'Could not add that one. Please try again, or message us on WhatsApp.'
      );


    } finally {

      button.removeAttribute(
        'aria-busy'
      );


      button.disabled =
        false;

    }

  }



  /* ==========================================================================
     CLICK HANDLING
     ========================================================================== */

  document.addEventListener(
    'click',

    function (
      event
    ) {


      /* --------------------------------------------------------------------
         COLLECTION FILTER
         -------------------------------------------------------------------- */

      var filterButton =
        event.target.closest(
          '[data-lv-filter]'
        );


      if (filterButton) {

        event.preventDefault();
        event.stopPropagation();


        showCollection(
          filterButton,
          false
        );


        return;

      }



      /* --------------------------------------------------------------------
         CLOSE VARIANT PANEL
         -------------------------------------------------------------------- */

      var closeButton =
        event.target.closest(
          '[data-lv-package-close]'
        );


      if (closeButton) {

        event.preventDefault();
        event.stopPropagation();


        var closePanel =
          closeButton.closest(
            '[data-lv-packages]'
          );


        closePackage(
          closePanel,
          true
        );


        return;

      }



      /* --------------------------------------------------------------------
         SELECT VARIANT
         -------------------------------------------------------------------- */

      var packageButton =
        event.target.closest(
          '[data-lv-package]'
        );


      if (packageButton) {

        event.preventDefault();
        event.stopPropagation();


        var panel =
          packageButton.closest(
            '[data-lv-packages]'
          );


        var card =
          packageButton.closest(
            '.lv-agrid__card'
          );


        var trigger =
          card &&
          card.querySelector(
            '[data-lv-add]'
          );


        var section =
          packageButton.closest(
            '[data-lv-agrid]'
          );


        var variantId =
          packageButton.getAttribute(
            'data-variant-id'
          );


        closePackage(
          panel,
          false
        );


        addVariant(
          trigger ||
          packageButton,
          variantId,
          section
        );


        return;

      }



      /* --------------------------------------------------------------------
         ADD / CHOOSE
         -------------------------------------------------------------------- */

      var addButton =
        event.target.closest(
          '[data-lv-add]'
        );


      if (addButton) {

        event.preventDefault();
        event.stopPropagation();


        var sectionElement =
          addButton.closest(
            '[data-lv-agrid]'
          );


        var directVariant =
          addButton.getAttribute(
            'data-variant-id'
          );


        /*
         * SINGLE VARIANT
         */

        if (directVariant) {

          closeAllPackages();


          addVariant(
            addButton,
            directVariant,
            sectionElement
          );


          return;

        }


        /*
         * MULTI VARIANT
         */

        var panelId =
          addButton.getAttribute(
            'aria-controls'
          );


        var target =
          panelId
            ? document.getElementById(
                panelId
              )
            : null;


        if (!target) return;


        if (target.hidden) {

          openPackage(
            target,
            addButton
          );

        } else {

          closePackage(
            target,
            true
          );

        }


        return;

      }



      /*
       * Clicking outside closes chooser.
       */

      if (
        !event.target.closest(
          '[data-lv-packages]'
        )
      ) {

        closeAllPackages();

      }

    }
  );



  /* ==========================================================================
     ESCAPE
     ========================================================================== */

  document.addEventListener(
    'keydown',

    function (
      event
    ) {

      if (
        event.key !==
        'Escape'
      ) {
        return;
      }


      var openPanel =
        document.querySelector(
          '[data-lv-packages]:not([hidden])'
        );


      if (!openPanel) return;


      event.preventDefault();


      closePackage(
        openPanel,
        true
      );

    }
  );



  /* ==========================================================================
     THEME CART EVENTS
     ========================================================================== */

  window.addEventListener(
    'theme:cart:updated',

    function () {

      refreshLisbonViceState();

    }
  );



  /* ==========================================================================
     INITIAL STATE
     ========================================================================== */

  function initialise() {

    initialiseCollectionPanels(
      document
    );


    refreshLisbonViceState();

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initialise
    );

  } else {

    initialise();

  }



  /* ==========================================================================
     SHOPIFY THEME EDITOR
     ========================================================================== */

  document.addEventListener(
    'shopify:section:load',

    function (
      event
    ) {

      var activityGrid =
        event.target.querySelector(
          '[data-lv-agrid]'
        );


      if (activityGrid) {

        initialiseCollectionPanels(
          event.target
        );


        refreshLisbonViceState();

      }

    }
  );


})();